import { VirtualDataProps } from '@/type/publicPropsType'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface LoadedDevicesProps {
  loadedDevicesPower: VirtualDataProps[]
}

const LoadedDevices: React.FC<LoadedDevicesProps> = ({ loadedDevicesPower }) => {
  const { t } = useTranslation()

  return (
    <div className='loaded-devices'>
      {loadedDevicesPower.map((item) => (
        <div className='one-device' key={item.label}>
          <img className='device-icon' src={`/assets/image/${item.label}.svg`} />
          <div className='load-value'>
            {item.value.toFixed(2)}&nbsp;
            <span>{item.unit}</span>
          </div>
          <div className='device-name'>{t(`site.${item.label}`)}</div>
        </div>
      ))}
    </div>
  )
}

export default LoadedDevices
